import { rolloutFlags } from '@chilipiper/rollout'
import { JwtService } from './types'
import { jwtApiV2 } from './jwtApiV2'
import { jwtApiV1 } from './jwtApiV1'

const isFallbackEnabled = () => rolloutFlags.authFallback?.isEnabled() ?? true

export const jwtApiV2WithV1Fallback = {
  refresh: async () => {
    try {
      const response = await jwtApiV2.refresh()
      return response['jwt-access']
    } catch (e) {
      if (isFallbackEnabled()) {
        return (await jwtApiV1.refresh()).accessToken
      }
      throw e
    }
  },
  getToken: () => {
    const v2Token = jwtApiV2.getToken()
    if (v2Token || !isFallbackEnabled()) {
      return v2Token
    }
    return jwtApiV1.getToken()
  },
  setToken: () => {
    throw new Error('setToken is not supported')
  },
  getSessionData: () => {
    throw new Error('getSessionData is not supported')
  },
  login: async initialFetchTokenCode => {
    try {
      const response = await jwtApiV2.login()
      return response['jwt-access']
    } catch (err) {
      if (isFallbackEnabled()) {
        return (await jwtApiV1.login(initialFetchTokenCode)).accessToken
      }
      throw err
    }
  },
  isAuthenticated: () => {
    const v2Auth = jwtApiV2.isAuthenticated()
    if (v2Auth || !isFallbackEnabled()) {
      return v2Auth
    }
    return jwtApiV1.isAuthenticated()
  },
  logout: async () => {
    if (isFallbackEnabled()) {
      await jwtApiV2.logout().catch(() => {
        /* ignore in case not logged in with V2 */
      })
      await jwtApiV1.logout()
    } else {
      await jwtApiV2.logout()
    }
  },
} satisfies JwtService<string>
